import React from 'react';

const Ayuda = () => {
    const ayudas = [
        {
            id: 1,
            titulo: "Cambio de rotación de paciente",
            icono: "bi-arrow-repeat",
            color: "primary",
            pasos: [
                { texto: "Cerrar acuerdos mutuos actuales", icono: "bi-x-circle" },
                { texto: "Cambiar rotación en la ficha del paciente", icono: "bi-person-gear" },
                { texto: "Abrir nuevos acuerdos mutuos", icono: "bi-check-circle" }
            ]
        },
        {
            id: 2,
            titulo: "Cambio de auxiliar (Sin cambiar rotación)",
            icono: "bi-person-plus",
            color: "info",
            pasos: [
                { texto: "Ir a Acuerdos Mutuos", icono: "bi-file-earmark-text" },
                { texto: "Seleccionar 'Actualizar'", icono: "bi-pencil-square" },
                { texto: "Asignar el nuevo auxiliar", icono: "bi-person-check" }
            ]
        },
        {
            id: 3,
            titulo: "Reemplazo puntual resuelto",
            icono: "bi-calendar-check",
            color: "success",
            pasos: [
                { texto: "Ir a la vista de Turnos", icono: "bi-calendar3" },
                { texto: "Seleccionar el turno específico", icono: "bi-cursor" },
                { texto: "Usar opción 'Reemplazar' y asignar auxiliar", icono: "bi-person-up" }
            ]
        },
        {
            id: 4,
            titulo: "Reemplazo a futuro (No resuelto)",
            icono: "bi-hourglass-split",
            color: "warning",
            pasos: [
                { texto: "Ir a Solicitudes de Reemplazo", icono: "bi-list-ul" },
                { texto: "Seleccionar 'Crear Solicitud'", icono: "bi-plus-square" },
                { texto: "Completar datos para que quede pendiente", icono: "bi-info-circle" }
            ]
        },
        {
            id: 5,
            titulo: "Descontar al auxiliar",
            icono: "bi-cash-stack",
            color: "danger",
            pasos: [
                { texto: "Actualizar 'Valor Turno'", icono: "bi-currency-dollar" },
                { texto: "Dejar nota explicativa clara", icono: "bi-sticky" }
            ]
        },
        {
            id: 6,
            titulo: "Fuera de Santiago",
            icono: "bi-geo-alt",
            color: "secondary",
            pasos: [
                { texto: "Crear Adicional", icono: "bi-plus-circle" },
                { texto: "Marcar opción 'Fuera de Santiago'", icono: "bi-check-square" },
                { texto: "Dejar nota explicativa", icono: "bi-chat-left-dots" }
            ]
        },
        {
            id: 7,
            titulo: "Paciente dado de baja",
            icono: "bi-person-dash",
            color: "dark",
            pasos: [
                { texto: "Ir a la nómina de Pacientes", icono: "bi-people" },
                { texto: "Seleccionar 'Retirar'", icono: "bi-door-open" },
                { texto: "Asignar motivo del retiro", icono: "bi-question-circle" },
                { texto: "Dejar nota final", icono: "bi-journal-text" }
            ]
        },
        {
            id: 8,
            titulo: "Horas Extras / Orientación",
            icono: "bi-clock-history",
            color: "dark",
            pasos: [
                { texto: "Ir a Crear Adicional", icono: "bi-plus-circle" },
                { texto: "Seleccionar auxiliar (ej. si es orientación)", icono: "bi-person-badge" },
                { texto: "Ingresar cantidad en 'Horas Extras'", icono: "bi-stopwatch" },
                { texto: "Dejar nota explicativa del motivo", icono: "bi-chat-right-text" }
            ]
        }
    ];

    return (
        <div className="container mt-4 mb-5">
            <div className="row mb-4">
                <div className="col-12">
                    <div className="card shadow-sm border-0 bg-primary text-white">
                        <div className="card-body p-4 text-center">
                            <h2 className="display-6 fw-bold mb-0">
                                <i className="bi bi-patch-question me-3"></i>
                                Centro de Ayuda & Definiciones
                            </h2>
                            <p className="lead mb-0 opacity-75">Guía rápida de procesos comunes para coordinación</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row g-4">
                {ayudas.map((ayuda) => (
                    <div key={ayuda.id} className="col-md-6 col-lg-4">
                        <div className="card h-100 shadow-sm border-0">
                            <div className={`card-header bg-${ayuda.color} text-white border-0 py-3`}>
                                <h5 className="card-title mb-0 d-flex align-items-center">
                                    <i className={`bi ${ayuda.icono} me-2`}></i>
                                    {ayuda.titulo}
                                </h5>
                            </div>
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    {ayuda.pasos.map((paso, idx) => (
                                        <li key={idx} className="list-group-item d-flex align-items-start border-0 px-0 py-2">
                                            <div className={`badge rounded-pill bg-${ayuda.color} bg-opacity-10 text-${ayuda.color} me-3 mt-1`}>
                                                <i className={`bi ${paso.icono}`}></i>
                                            </div>
                                            <span className="small text-dark fw-medium">{paso.texto}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="card-footer bg-white border-0 pb-3">
                                <div className="progress" style={{ height: '4px' }}>
                                    <div className={`progress-bar bg-${ayuda.color}`} role="progressbar" style={{ width: '100%' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-5 text-center p-4 bg-light rounded shadow-sm border">
                <p className="text-muted mb-0">
                    <i className="bi bi-info-circle-fill me-2 text-primary"></i>
                    Si el proceso que buscas no está aquí, por favor contacta al equipo de soporte.
                </p>
            </div>
        </div>
    );
};

export default Ayuda;
